/* RESPONSIBLE TEAM: team-inbox */
import JSONAPIAdapter from '../json-api';

export default JSONAPIAdapter.extend({});
